import gamesScore from "./gamesScore";
import {
	getGameState,
	getMyRank,
	getWords,
	deleteGameState,
	saveActivity,
} from "@/utils/apiFunctions";
import { wordList, guessList } from "@/utils/stringArrays";
import CryptoJS from "crypto-js";
export default {
	mixins: [gamesScore],
	data() {
		return {
			GAME_ENCRYPTION_KEY: "M3kyY2RYu9tVUZcU",
			encryptedWord: "",
			guessWords: [],
			guessedWords: [],
			height: 6,
			width: 5,
			row: 0,
			col: 0,
			gameOver: false,
			showError: false,
			word: "",
			inputField: null,
			wordList: wordList,
			guessList: guessList,
			isLaptop: false,
			myScore: 0,
			bestTry: 0,
			currentSeries: 0,
			response: null,
			activityInterval: null,
		};
	},
	watch: {
		gameOver() {
			if (this.gameOver) {
				this.handleGameOver();
				if (
					this.word.toUpperCase() ===
					this.guessWords[this.guessWords.length - 1].toUpperCase()
				) {
					this.submitScore("wordle", 7 - this.guessWords.length);
				} else {
					this.submitScore("wordle", 0);
				}
			}
		},
	},
	mounted() {
		this.startActivityTimer();
		this.initialize();
		window.addEventListener("resize", this.checkScreenSize);
		this.checkScreenSize();
		this.getMyRank();
		window.addEventListener("orientationchange", () => {
			setTimeout(() => {
				if (document.activeElement === this.inputField) {
					const tile = document.getElementById(`${this.row}-${this.col}`);
					if (tile) {
						const tileRect = tile.getBoundingClientRect();
						window.scrollTo({
							top: window.scrollY + tileRect.top - window.innerHeight * 0.4,
							behavior: "smooth",
						});
					}
				}
			}, 300);
		});
	},
	beforeDestroy() {
		document.removeEventListener("keyup", this.processInput);
		clearInterval(this.activityInterval);
		window.removeEventListener(
			"orientationchange",
			this.handleOrientationChange
		);
	},

	methods: {
		decryptWord(encryptedWord) {
			try {
				const encryptedData = CryptoJS.enc.Base64.parse(encryptedWord);

				// Extract IV (first 16 bytes) and ciphertext
				const iv = CryptoJS.lib.WordArray.create(
					encryptedData.words.slice(0, 4)
				);
				const ciphertext = CryptoJS.lib.WordArray.create(
					encryptedData.words.slice(4)
				);

				// Decrypt using AES-CBC
				const decrypted = CryptoJS.AES.decrypt(
					{ ciphertext },
					CryptoJS.enc.Utf8.parse(this.GAME_ENCRYPTION_KEY),
					{ iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
				);
				return decrypted.toString(CryptoJS.enc.Utf8);
			} catch (error) {
				console.error("Decryption failed:", error);
				return null;
			}
		},
		async newGame() {
			const res = await deleteGameState("wordle");
			this.guessWords = [];
			this.guessedWords = [];
			this.currentSeries = 0;
			this.word = "";
			this.gameOver = false;
			this.col = 0;
			this.row = 0;
			this.showError = false;

			const board = document.getElementById("board");
			if (board) board.innerHTML = "";

			const keyboard = document.getElementById("keyboard");
			if (keyboard) keyboard.remove();

			if (res.status === 200) {
				await this.initialize();
			}
		},
		startActivityTimer() {
			this.activityInterval = setInterval(async () => {
				await saveActivity("wordle");
			}, 30000);
		},
		handleGameOver() {
			this.showError = true;
			setTimeout(() => {
				const answerElement = document.getElementById("answer");
				if (answerElement) {
					answerElement.style.left = "111px";
					answerElement.innerText = this.word.toUpperCase();
					this.showError = true;
					setTimeout(() => {
						this.showError = false;
						answerElement.innerText = "";
						const gameWon =
							this.guessWords[this.guessWords.length - 1].toUpperCase() ===
							this.word.toUpperCase();
						const score = gameWon ? 6 - this.guessWords.length : 0;
						this.$emit("gameOver", gameWon, score, this.word);
					}, 5000);
				}
			}, 0);
		},

		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},

		updateActiveTile() {
			// Remove active class from all tiles
			document.querySelectorAll(".tile").forEach((tile) => {
				tile.classList.remove("active");
			});

			// Add active class to current tile if game isn't over
			if (!this.gameOver && this.col < this.width) {
				const activeTile = document.getElementById(`${this.row}-${this.col}`);
				if (activeTile) {
					activeTile.classList.add("active");
				}
			}
		},

		async initialize() {
			// const deletea = await deleteGameState("wordle");
			const res = await getGameState("wordle");
			const words = await getWords();
			if (res.status == 200) {
				this.response = res;
				// this.guessList = this.guessList.concat(this.wordList);
				this.guessList = words.data;
				// this.word =
				// 	res.data.data.state?.game_data?.word || res.data.data.state?.word;
				this.encryptedWord =
					res.data.data.state?.game_data?.word || res.data.data.state?.word;

				if (this.encryptedWord) {
					this.word = this.decryptWord(this.encryptedWord); // Decrypt the word
				}

				this.guessedWords = res.data.data.state?.guessedWords || [];
				this.guessWords = [...this.guessedWords];
				this.currentSeries = res.data.data.serial || 0;
			} else {
				this.guessList = this.guessList.concat(this.wordList);
				this.word =
					this.wordList[
						Math.floor(Math.random() * this.wordList.length)
					].toUpperCase();
			}

			for (let r = 0; r < this.height; r++) {
				for (let c = 0; c < this.width; c++) {
					let tile = document.createElement("span");
					tile.id = `${r}-${c}`;
					tile.classList.add("tile");
					tile.innerText = "";
					if (!this.isLaptop) {
						tile.addEventListener("click", this.focusInput);
					}
					document.getElementById("board").appendChild(tile);
				}
			}

			// let keyboard = [
			// 	["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
			// 	["A", "S", "D", "F", "G", "H", "J", "K", "L"],
			// 	[ "Z", "X", "C", "V", "B", "N", "M"],
			// ];
			let keyboard = [
				["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
				["A", "S", "D", "F", "G", "H", "J", "K", "L"],
				["Enter", "Z", "X", "C", "V", "B", "N", "M", "⌫"],
			];
			const keyboardContainer = document.createElement("div");
			keyboardContainer.id = "keyboard";
			keyboardContainer.classList.add("keyboard-container");

			for (let i = 0; i < keyboard.length; i++) {
				let currRow = keyboard[i];
				let keyboardRow = document.createElement("div");
				keyboardRow.classList.add("keyboard-row", `keyboard-row-${i + 1}`);

				for (let j = 0; j < currRow.length; j++) {
					let keyTile = document.createElement("div");
					let key = currRow[j];
					keyTile.innerText = key;

					if (key === "Enter") {
						keyTile.id = "Enter";
						keyTile.classList.add("enter-key-tile");
					} else if (key === "⌫") {
						keyTile.id = "Backspace";
						keyTile.classList.add("key-tile");
					} else if ("A" <= key && key <= "Z") {
						keyTile.id = "Key" + key;
						keyTile.classList.add("key-tile");
					}

					keyTile.addEventListener("click", () => {
						this.processKey(keyTile.id);
					});

					keyboardRow.appendChild(keyTile);
				}
				keyboardContainer.appendChild(keyboardRow);
			}

			document.getElementById("wordle").appendChild(keyboardContainer);

			// Initialize existing guessed words
			for (
				let r = 0;
				r < Math.min(this.height, this.guessedWords.length);
				r++
			) {
				let guess = this.guessedWords[r];
				for (let c = 0; c < this.width; c++) {
					let currTile = document.getElementById(`${r}-${c}`);
					if (c < guess.length) {
						currTile.innerText = guess[c].toUpperCase();
						this.update("existing");
					}
				}
			}

			// Add initial active tile indicator
			this.updateActiveTile();
			this.storeData();
			document.addEventListener("keyup", this.processInput);
			this.$emit("gameLoaded");
		},

		focusInput(event) {
			let targetTile = event.target;

			if (!this.inputField) {
				this.inputField = document.createElement("input");
				this.inputField.type = "text";
				this.inputField.readOnly = true;
				this.inputField.style.position = "fixed"; // Change to fixed positioning
				this.inputField.style.top = "50%"; // Position in middle of screen
				this.inputField.style.left = "50%"; // Center horizontally
				this.inputField.style.transform = "translate(-50%, -50%)"; // Center properly
				this.inputField.style.opacity = "0";
				this.inputField.style.height = "1px";
				this.inputField.style.width = "1px";
				this.inputField.style.zIndex = "-1"; // Ensure it's below other elements
				document.body.appendChild(this.inputField);

				// Add these meta tags in your HTML head to prevent zoom and ensure proper viewport
				const viewportMeta = document.createElement("meta");
				viewportMeta.name = "viewport";
				viewportMeta.content =
					"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
				document.head.appendChild(viewportMeta);

				document.body.appendChild(this.inputField);

				// Prevent scroll on focus
				this.inputField.addEventListener("focus", () => {
					// Delay the scroll to ensure the keyboard is open
					setTimeout(() => {
						// Calculate the target tile's position
						const tile = document.getElementById(`${this.row}-${this.col}`);
						if (tile) {
							const board = document.getElementById("board");
							const boardRect = board.getBoundingClientRect();
							const tileRect = tile.getBoundingClientRect();

							// Calculate the ideal scroll position
							const idealScrollTop =
								window.scrollY + tileRect.top - window.innerHeight * 0.4;

							// Smooth scroll to the position
							window.scrollTo({
								top: idealScrollTop,
								behavior: "smooth",
							});
						}
					}, 300);
				});

				this.inputField.addEventListener("input", (e) => {
					let value = e.target.value.toUpperCase();
					if (value.length > 0) {
						let currTile = document.getElementById(`${this.row}-${this.col}`);
						if (currTile && this.col < this.width) {
							currTile.innerText = value.charAt(value.length - 1);
							this.col += 1;
							this.updateActiveTile();
						}
					}
					e.target.value = "";
				});

				// Handle keyboard closing
				window.addEventListener("resize", () => {
					// If keyboard closes, reset scroll position smoothly
					if (document.activeElement === this.inputField) {
						setTimeout(() => {
							window.scrollTo({
								top: 0,
								behavior: "smooth",
							});
						}, 100);
					}
				});

				this.inputField.addEventListener("keydown", (e) => {
					if (e.key === "Enter") {
						this.processInput({ code: "Enter" });
						e.preventDefault();
					} else if (e.key === "Backspace") {
						if (this.col > 0) {
							this.col -= 1;
							let currTile = document.getElementById(`${this.row}-${this.col}`);
							currTile.innerText = "";
							this.updateActiveTile();
						}
						e.preventDefault();
					}
				});
			}

			// Focus the input field with a slight delay to ensure smooth animation
			setTimeout(() => {
				this.inputField.focus();
			}, 50);

			document.addEventListener("click", this.closeInputOnClickOutside);
		},
		processKey(keyId) {
			if (this.gameOver) return;

			if (keyId.startsWith("Key")) {
				const letter = keyId.slice(3);
				if (this.col < this.width) {
					let currTile = document.getElementById(`${this.row}-${this.col}`);
					if (currTile.innerText === "") {
						currTile.innerText = letter;
						this.col += 1;
						this.updateActiveTile();
					}
				}
			} else if (keyId === "Backspace") {
				// Modified backspace handling
				if (this.col > 0) {
					this.col -= 1;
					let currTile = document.getElementById(`${this.row}-${this.col}`);
					currTile.innerText = "";
					this.updateActiveTile();
				}
			} else if (keyId === "Enter") {
				this.update("Enter");
			}

			if (!this.gameOver && this.row === this.height) {
				this.gameOver = true;
				document.getElementById("answer").innerText = this.word;
			}
		},
		async getMyRank() {
			const res = await getMyRank("wordle");
			if (res.status == 200) {
				this.myScore = res.data.data.current_score || 0;
				const bestScore = res.data.data.all_scores;
				const minScore =
					bestScore.length > 0
						? Math.max(...bestScore.map((scoreObj) => scoreObj.score))
						: 0;
				this.bestTry = minScore > 0 ? 7 - minScore : 0;
			}
		},

		processInput(e) {
			if (this.gameOver) return;
			if ("KeyA" <= e.code && e.code <= "KeyZ") {
				if (this.col < this.width) {
					let currTile = document.getElementById(`${this.row}-${this.col}`);
					if (currTile.innerText === "") {
						currTile.innerText = e.code[3];
						this.col += 1;
						this.updateActiveTile();
					}
				}
			} else if (e.code === "Backspace" || e.keyCode === 8) {
				if (0 < this.col && this.col <= this.width) {
					this.col -= 1;
				}
				let currTile = document.getElementById(`${this.row}-${this.col}`);
				currTile.innerText = "";
				this.updateActiveTile();
			} else if (e.code === "Enter") {
				this.update(e.code);
			}

			if (!this.gameOver && this.row === this.height) {
				this.gameOver = true;
				document.getElementById("answer").innerText = this.word;
			}
		},

		update(e) {
			let guess = "";
			for (let c = 0; c < this.width; c++) {
				let currTile = document.getElementById(`${this.row}-${c}`);
				let letter = currTile.innerText;
				guess += letter;
			}

			guess = guess.toLowerCase();
			if (guess.length !== this.width) return;
			if (!this.guessList.includes(guess)) {
				if (e === "Enter") {
					this.showError = true;
					setTimeout(() => {
						const answerElement = document.getElementById("answer");

						if (answerElement) {
							answerElement.innerText = "Not in word list";

							setTimeout(() => {
								this.showError = false;
								if (answerElement.innerText !== "") {
									answerElement.innerText = "";
								}
							}, 2000);
						}
					}, 0);
				}
				this.shakeRow(this.row);
				return;
			}

			if (e === "Enter") {
				this.guessWords.push(guess);
			}

			let correct = 0;
			let letterCount = {};

			// Build frequency map of target word
			for (let i = 0; i < this.word.length; i++) {
				let letter = this.word[i];
				letterCount[letter] = (letterCount[letter] || 0) + 1;
			}

			for (let c = 0; c < this.width; c++) {
				let currTile = document.getElementById(`${this.row}-${c}`);
				let letter = currTile.innerText;

				if (this.word[c] === letter) {
					currTile.setAttribute("data-result", "correct");
					letterCount[letter] -= 1;
					correct += 1;
				}
			}

			// Second pass: mark present and absent letters
			for (let c = 0; c < this.width; c++) {
				let currTile = document.getElementById(`${this.row}-${c}`);
				let letter = currTile.innerText;

				// Skip if already marked as correct
				if (currTile.getAttribute("data-result") === "correct") continue;

				if (this.word.includes(letter) && letterCount[letter] > 0) {
					currTile.setAttribute("data-result", "present");
					letterCount[letter] -= 1;
				} else {
					currTile.setAttribute("data-result", "absent");
				}
			}

			// Now animate the tiles and apply classes
			for (let c = 0; c < this.width; c++) {
				let currTile = document.getElementById(`${this.row}-${c}`);
				let result = currTile.getAttribute("data-result");
				let letter = currTile.innerText;

				setTimeout(() => {
					currTile.classList.add("flip");

					setTimeout(() => {
						currTile.classList.add(result);

						let keyTile = document.getElementById(`Key${letter}`);
						if (result === "correct") {
							keyTile.classList.remove("present");
							keyTile.classList.add("correct");
						} else if (result === "present") {
							if (!keyTile.classList.contains("correct")) {
								keyTile.classList.remove("absent");
								keyTile.classList.add("present");
							}
						} else if (result === "absent") {
							if (!this.word.includes(letter)) {
								keyTile.classList.add("absent");
							}
						}

						if (correct === this.width) {
							this.gameOver = true;
						}

						// Optional: clean up flip animation
						setTimeout(() => {
							currTile.classList.remove("flip");
						}, 600);
					}, 350);
				}, c * 300);
			}

			this.row += 1;
			this.col = 0;
			if (e === "Enter") {
				this.storeData();
			}
			this.updateActiveTile();
		},

		shakeRow(rowIndex) {
			for (let c = 0; c < this.width; c++) {
				let currTile = document.getElementById(`${rowIndex}-${c}`);
				currTile.classList.add("shake");
			}

			setTimeout(() => {
				for (let c = 0; c < this.width; c++) {
					let currTile = document.getElementById(`${rowIndex}-${c}`);
					currTile.classList.remove("shake");
				}
			}, 500);
		},

		closeInputOnClickOutside(event) {
			if (this.inputField && !event.target.closest("#board")) {
				this.inputField.blur();
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}
		},

		storeData() {
			const wonGame = () => {
				if (
					this.word?.toUpperCase() ===
					this.guessWords[this.guessWords.length - 1]?.toUpperCase()
				) {
					return true;
				}
				return false;
			};
			let gameState = {
				gameOver: this.gameOver || false,
				word: this.encryptedWord,
				guessedWords: this.guessWords || [],
				wonGame: wonGame(),
			};
			console.log("it is working");
			this.saveGameState("wordle", gameState);
		},
	},
};
